const ID3V1_TAG_BYTES = 128;

// An ID3v1 tag is a fixed 128-byte block at the very end of the file, so its size is known once its "TAG" marker is found
export const readId3v1Bytes = async (audioFile: File): Promise<number> => {
  const tailStart = audioFile.size - ID3V1_TAG_BYTES;
  if (tailStart < 0) {
    return 0;
  }

  const tailBytes = new Uint8Array(
    await audioFile.slice(tailStart, tailStart + 3).arrayBuffer()
  );
  const isId3v1Tag =
    tailBytes[0] === 0x54 && tailBytes[1] === 0x41 && tailBytes[2] === 0x47;
  return isId3v1Tag ? ID3V1_TAG_BYTES : 0;
};
